import { Component, inject, Input, OnChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GeneralErrorComponent } from '../../shared/ui/general-error/general-error.component';
import { Router } from '@angular/router';
import { RoutePaths } from '../../../core/constants/route-paths';
import { Content } from '../type/content';
import {
  LOCAL_LANG,
  LOCAL_STORAGE_TOKEN,
} from '../../../core/constants/constants';
import { LOCAL_STORAGE_EXT_TOKEN } from '../../../core/constants/constants';
import { LOCAL_STORAGE_INT_TOKEN } from '../../../core/constants/constants';
import { DataLayerService } from '../../../core/services/data-layer.service';

@Component({
  selector: 'app-content-item',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule, GeneralErrorComponent],
  templateUrl: './content-item.component.html',
  styleUrls: ['./content-item.component.scss'],
})
export class ContentItemComponent implements OnInit, OnChanges {
  @Input() content!: Content;
  @Input() managView: boolean = false;
  language: string = 'es';
  title: string = '';
  description: string = '';

  private _router: Router = inject(Router);
  private readonly _dataLayerService = inject(DataLayerService);
  private readonly _translateService = inject(TranslateService);
  screenName = 'content';

  ngOnInit(): void {}

  ngOnChanges(): void {
    this.translateContent();
  }

  translateContent(): void {
    const lang = localStorage.getItem(LOCAL_LANG);
    this.language = lang || 'es';

    if (this.managView) {
      this.title = this.content.title;
      this.description = this.content.description;
      return;
    }
    if (this.language === 'pt') {
      this.title = this.content.title_pt || this.content.title;
      this.description =
        this.content.description_pt || this.content.description;
    } else if (this.language === 'en') {
      this.title = this.content.title_en || this.content.title;
      this.description =
        this.content.description_en || this.content.description;
    } else {
      this.title = this.content.title;
      this.description = this.content.description;
    }
  }

  async handleRedirect(): Promise<void> {
    this._dataLayerService.pushEventClickLink(
      '',
      'update-content',
      'Gestionar contenido',
      'content actions'
    );
    if (!this.content || !this.content.content) {
      return;
    }
    await this._router.navigate([
      `${RoutePaths.contentEditor}`,
      this.content.content,
    ]);
  }

  async handleRedirectPWBI(): Promise<void> {
    const url = this._router.serializeUrl(
      this._router.createUrlTree([
        `${RoutePaths.contentPowerBI}`,
        this.content.content,
      ])
    );
    window.open(url, '_blank');
  }

  async handleRedirectGEMA(url: string): Promise<void> {
    const token = localStorage.getItem(LOCAL_STORAGE_TOKEN) ?? '';
    const internalToken = localStorage.getItem(LOCAL_STORAGE_INT_TOKEN);
    const externalToken = localStorage.getItem(LOCAL_STORAGE_EXT_TOKEN);
    let userKey = '';

    if (internalToken) {
      userKey = 'internal_user_token';
    } else if (externalToken) {
      userKey = 'external_user_token';
    } else {
      console.error('No valid token found in localStorage');
      return;
    }

    const targetWindow = window.open(url, '_blank');
    let retries = 0;

    setTimeout(() => {
      if (targetWindow && !targetWindow.closed) {
        const targetOrigin = new URL(url).origin;
        const message = {
          token: token,
          user: userKey,
          lang: this.language,
        };
        targetWindow.postMessage(message, targetOrigin);

        const intervalid = setInterval(() => {
          targetWindow.postMessage(message, targetOrigin);
          retries++;
          if (intervalid && retries > 20) {
            clearInterval(intervalid);
          }
        }, 1000);

        window.addEventListener('message', (event) => {
          if (event.data === 'ACK') {
            retries = 21;
            if (intervalid) {
              clearInterval(intervalid);
            }
          }
        });
      } else {
        console.error('GEMA window was closed before sending message');
      }
    }, 500);
  }

  getLinkUrl(content: any): string | null {
    if (content.url.includes('POWERBI') || content.content === 'GEMA') {
      return null;
    }
    return content.url;
  }

  handleClick(content: any, event: Event): void {
    const text = this._translateService.instant(
      !this.managView ? 'content.offert' : 'Test'
    );
    this._dataLayerService.pushEventClickLink('', text, content.content, 'cta');

    if (content.url.includes('POWERBI')) {
      event.preventDefault();
      this.handleRedirectPWBI();
    } else if (content.content === 'GEMA') {
      event.preventDefault();
      this.handleRedirectGEMA(content.url);
    }
  }
}
